import './globals.js';
import React from 'react';
import ReactDOM from 'react-dom';
import {App} from './components/App';
import * as serviceWorker from './serviceWorker';
import './version.js';
import './useRDP.js';
import './index.css';
import { CoreUIProvider } from '@v2cloud/react';
import { initializeFeatureFlags } from './feature_flags.js';

// Debug affordance: the client-side copilot prototype is no longer mounted at
// startup. Run `startCopilotPrototype()` in the DevTools console to load it on
// demand — the prototype bundle is code-split, so it only downloads when called.
window.startCopilotPrototype = () =>
  import('./kyotoPrototype.js').then((m) => m.startCopilotPrototype());

await initializeFeatureFlags();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CoreUIProvider>
      <App />
    </CoreUIProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();